(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbContentTypeGroupSearch',
		[
			ContentTypeGroupSearchDirective
		])
		.controller('ContentTypeGroupSearchController',
		[
			'$state',
			'gettextCatalog',
			'pxProgressService',
			'smbToolbarService',
			'smbIndexTypesDataStore',
			'smbContentSearchDataStore',
			'smbContentTypeGroupConfigDataStore',
			'smbContentTypeConfigDataStore',
			'smbIconTypes',
			ContentTypeGroupSearchController
		]);

	var templateUrl = require('./contentTypeGroupSearch.template');
	function ContentTypeGroupSearchDirective() {
		return {
			restrict: 'E',
			controller: ContentTypeGroupSearchController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: {
				groupId: '@'
			},
			scope: {}
		};
	}

	function ContentTypeGroupSearchController($state, gettextCatalog, pxProgressService, smbToolbarService, smbIndexTypesDataStore, 
										smbContentSearchDataStore, smbContentTypeGroupConfigDataStore, smbContentTypeConfigDataStore, smbIconTypes) {

		smbToolbarService.set(gettextCatalog.getString('Search Document Type Group'), 'search.contentTypeGroups.contentTypes', false, false);

		var vm = this;

		vm.search = search;
		vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
		vm.contentTypeDS = smbContentTypeConfigDataStore;
		vm.contentTypeGroupDS = smbContentTypeGroupConfigDataStore;
		vm.indexTypesDS = smbIndexTypesDataStore;
		vm.filename = null;

		vm.indextypes = [];

		vm.contentTypeGroupDS.getContentTypeGroup(vm.groupId)		
		.then(function () {
			vm.indexTypesDS.getDocumentTypeGroupIndexTypes(vm.groupId).then(function () {
				vm.indextypes = vm.indexTypesDS.groupIndexTypes;
			});
		});

		function search() {
			smbContentSearchDataStore.setTagValues(vm.indextypes);
			$state.go('search.contentTypeGroups.contentTypes.groupSearch.results',{ groupId: vm.groupId});
		}
	}
}());



//////////////////
// WEBPACK FOOTER
// ./app/components/contentTypeGroupSearch/contentTypeGroupSearch.js
// module id = 70
// module chunks = 1